import { motion } from "framer-motion";

const MandiTradesPage = () => {
  return (
    <div data-testid="mandi-page" className="pt-20">
      {/* Hero */}
      <section className="py-16 md:py-24 bg-black min-h-[100dvh] flex items-center">
        <div className="max-w-[900px] mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <div className="inline-block glass px-4 py-2 rounded-full mb-6">
              <span className="text-sm font-medium text-[#F5F5F7]">Product Solution</span>
            </div>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-semibold text-[#F5F5F7] tracking-tight mb-8" data-testid="mandi-title">
              Mandi Trades
            </h1>
            
            {/* Technical Summary */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="service-card p-8 text-left max-w-3xl mx-auto"
            >
              <p className="text-lg text-[#86868B] leading-relaxed">
                <strong className="text-[#F5F5F7]">Mandi Trades</strong> is a digital platform designed to streamline agricultural commodity trading operations. 
                The system provides real-time trade tracking, automated invoicing, payment reconciliation, and settlement management. 
                Built with integrations for accounting systems, SMS/WhatsApp notifications, bank file processing, and ERP connectivity — 
                enabling mandi operators, traders, and farmers to digitize workflows, reduce manual errors, and maintain complete audit trails 
                across the commodity supply chain.
              </p>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default MandiTradesPage;
